module.exports = __webpack_public_path__ + "img/suyuan-example.png";